var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.2266 5.48438V18.6875C17.2266 19.3984 16.6523 19.9727 15.9414 19.9727H4.05859C3.34766 19.9727 2.77344 19.3984 2.77344 18.6875V1.30469C2.77344 0.59375 3.34766 0.0195312 4.05859 0.0195312H11.7617L17.2266 5.48438Z",
    fill: "#23A566",
    style: (_ref2 = {
      fill: "#23A566"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.1373 0.6471 0.4000)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1602 9.95703H6.83984C6.61328 9.95703 6.42969 10.1406 6.42969 10.3672V15.8711C6.42969 16.0977 6.61328 16.2812 6.83984 16.2812H13.1641C13.3906 16.2812 13.5742 16.0977 13.5742 15.8711V10.3711C13.5703 10.1445 13.3867 9.95703 13.1602 9.95703ZM7.25 12.5977H9.58984V13.6406H7.25V12.5977ZM10.4102 12.5977H12.75V13.6406H10.4102V12.5977ZM12.75 11.7773H10.4102V10.7813H12.75V11.7773ZM9.58984 10.7813V11.7773H7.25V10.7813H9.58984ZM7.25 14.4648H9.58984V15.4609H7.25V14.4648ZM10.4102 15.4609V14.4648H12.75V15.4609H10.4102Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M12.5 5.28906L17.2305 9.12109V5.52344L14.5469 3.96484L12.5 5.28906Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2227 5.48438H13.043C12.332 5.48438 11.7578 4.91016 11.7578 4.19922V0.0195312L17.2227 5.48438Z",
    fill: "#8ED1B1",
    style: (_ref3 = {
      fill: "#8ED1B1"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.5569 0.8196 0.6941)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.1a9de3b4.svg";
export { ForwardRef as ReactComponent };